import styled, { css } from 'styled-components';
import tw from 'twin.macro';

export const Container = styled.div`
  ${tw`flex justify-between items-center w-full`};
`;

export const ProgressContainer = styled.div<{ isDone: boolean }>`
  ${tw`mr-2 h-4px rounded-16px flex-grow-default`};
  ${(props) => (props.isDone ? tw`bg-blue-600` : tw`bg-blue-gray-200`)}
`;

export const NumberedProgressBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
`;

export const NumberedProgressBarStepContainer = styled.div<{
  customStyles?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 0;
  max-width: 224px;

  @media (max-width: 400px) {
    width: 72px;
  }

  .current-step-number {
    background-color: #0b84ff;
    color: #ffffff;
    border: 2px solid #0b84ff;
  }

  .current-step-text {
    color: #0b84ff;
  }

  .final-step-number,
  .finished-step-number {
    background-color: #5ec269;
    color: #ffffff;
    border: 2px solid #5ec269;
  }

  .final-step-text,
  .finished-step-text {
    color: #5ec269;
  }

  ${({ customStyles }) =>
    customStyles &&
    css`
      ${customStyles}
    `}
`;

export const NumberedProgressBarStepNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  color: #9ca3af;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  font-family: Inter;
  border: 2px solid #e5e7eb;
`;

export const NumberedProgressBarStepText = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #9ca3af;
  margin-top: 4px;
  font-family: Inter;
  text-align: center;
`;

export const ProgressBarContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  display: flex;
  z-index: 0;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
`;
export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: #e5e7eb;
`;
export const ProgressBarFiller = styled.div`
  height: 100%;
  background-color: #5ec269;
  width: ${(props) => props.width}%;
`;
